<div class="modal-backdrop" 
     [ngClass]="{'is-visible': isVisible, 'is-hidden': !isVisible}"
     (click)="onBackdropClick($event)">
  <section class="results-modal" 
           [ngClass]="{'is-visible': isVisible, 'is-hidden': !isVisible, 'modal-large': tableData}"
           (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h2 class="modal-title">{{ title }}</h2>
          <p class="modal-subtitle" *ngIf="headerInfo">{{ headerInfo }}</p>
        </div>
        <button class="close-button" (click)="closeModal()" aria-label="Cerrar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <div class="modal-divider"></div>
      
      <div class="modal-body">
        <!-- Vista Simple (para resultados simples) -->
        <div class="results-grid" *ngIf="!tableData && results.length > 0">
          <div class="result-item" *ngFor="let result of results">
            <div class="result-label">{{ result.label }}</div>
            <div class="result-value">{{ result.value }}</div>
          </div>
        </div>

        <!-- Vista de Tabla (para datos tabulares) -->
        <div class="table-container" *ngIf="tableData">
          <table class="results-table">
            <thead>
              <tr>
                <th *ngFor="let column of tableData.columns">{{ column.header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of tableData.rows; let i = index">
                <td *ngFor="let column of tableData.columns">
                  <span *ngIf="column.key === 'index'">{{ i + 1 }}</span>
                  <span *ngIf="column.key !== 'index'">{{ getNestedValue(row, column.key) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="close-action-button" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </section>
</div>
